import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { loginUser, getCurrentUser } from "actions/AuthAction";
import { getDashboardPath } from "services/api";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_KEYS } from "utils/siteAssets";

function Cover() {
  const [rememberMe, setRememberMe] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginProses, setLoginProses] = useState(false);
  const navigate = useNavigate();
  const { getAssetUrl } = useSiteAssets();
  const bgImage = getAssetUrl(SITE_ASSET_KEYS.BG_LOGIN);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.token) {
      navigate(getDashboardPath(user.role));
    }
  }, [navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!username || !password) {
      alert("Username dan password wajib diisi");
      return;
    }
    setLoginProses(true);
    loginUser(username, password, setLoginProses, navigate);
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" mx={2} mt={2} p={3} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            TIALAI
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Pelayanan Perizinan Kabupaten Rote Ndao
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Username"
                variant="standard"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                variant="standard"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} />
              <MDTypography variant="button" color="text" sx={{ ml: -1 }}>
                Ingat saya
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loginProses}>
                {loginProses ? "Memproses..." : "Masuk"}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Belum punya akun?{" "}
                <MDTypography component={Link} to="/authentication/sign-up/cover" variant="button" color="info" fontWeight="medium" textGradient>
                  Daftar Pemohon
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
